import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=b1a1307a&scoped=true&"
import script from "./bind.vue?vue&type=script&lang=js&"
export * from "./bind.vue?vue&type=script&lang=js&"
import style0 from "./bind.vue?vue&type=style&index=0&id=b1a1307a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a1307a",
  null
  
)

export default component.exports